webpackJsonp([65],{

/***/ "w7PE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

$(document).ready(function () {
    changeModelDisplay();
    $('#download_file_form_type').on('change', function () {
        $("#download_file_form_model").val('');
        changeModelDisplay();
    });

    function changeModelDisplay() {
        var type = parseInt($('#download_file_form_type').val());
        $("#download_file_form_model option").each(function () {
            var modelType = $(this).data('type');

            if (type === modelType || $(this).data('type') === undefined) {
                $(this).attr('style', 'display: block');
            } else {
                $(this).attr('style', 'display: none');
            }
        });
    }

    function isTypeSelected() {
        return $('#download_file_form_type').val() !== '';
    }

    function enableModelForm() {
        $('#download_file_form_model').attr('disabled', false);
    }

    function disableModelForm() {
        $('#download_file_form_model').attr('disabled', 'disabled');
    }

    function toggleModelFormDisable() {

        if (isTypeSelected()) {
            enableModelForm();
        } else {
            disableModelForm();
        }
    }

    toggleModelFormDisable();

    $('#download_file_form_type').on('input', function () {
        toggleModelFormDisable();
    });
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ })

},["w7PE"]);


// WEBPACK FOOTER //
// js/front/download-file-list.eafc14ad.js